import axios from 'axios';

const { REACT_APP_PORTALI_REF_API } = window.__RUNTIME_CONFIG__;

const client = axios.create({
    baseURL: REACT_APP_PORTALI_REF_API,
    responseType: 'json'
});

export default client;
